import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'react-tooltip';

const CustomTooltip = ({ id, tooltipText }) => {
  return (
    <Tooltip id={id} place="left" type="info" effect="float" multiline={true}>
      {tooltipText || <span className="fa fa-info-circle"></span>}
    </Tooltip>
  );
};

CustomTooltip.propTypes = {
  id: PropTypes.string.isRequired,
  tooltipText: PropTypes.string,
};

export default CustomTooltip;
